
import { Component, Vue } from 'vue-property-decorator'
import { Http } from '../../lib/utils/Http'

import BacButton from '@/components/BacButton.vue'
import BacAlert from '@/components/BacAlert.vue'

@Component({
  components: {
    BacButton,
    BacAlert
  }
})
export default class DbCheck extends Vue {
  finishedWithoutTeamnumber: number[] = [];
  finishedWithoutTeam: number[] = [];
  finishedWithoutTeamname: number[] = [];
  finishedWithoutTeamtorally: number[] = [];
  finishedWithoutCustomertoteam: number[] = [];
  finishedWithDivertingTeamname: number[] = [];
  finishedWithDivertingTeamdescription: number[] = [];
  finishedWithDivertingTeamnumber: number[] = [];
  doubleTeamnumbers: [][] = []
  hasTeamnumberButNotReserved: number[] = [];

  noTeamnameFixes = -1;
  noTeamtorallyFixes = -1;
  noCustomertoteamFixes = -1

  mounted () {
    this.loadFinishedWithoutTeamnumber()
    this.loadFinishedWithoutTeam()
    this.loadFinishedWithoutTeamname()
    this.loadFinishedWithoutTeamtorally()
    this.loadFinishedWithoutCustomertoteam()
    this.loadFinishedWithDivertingTeamnumber()
    this.loadFinishedWithDivertingTeamname()
    this.loadFinishedWithDivertingTeamdescription()
    this.loadDoubleTeamnumbers()
    this.loadHasTeamnumberButNotReserved()
  }

  get hasTeamnumberButNotReservedString () {
    if (!this.hasTeamnumberButNotReserved) {
      return ''
    }
    return this.hasTeamnumberButNotReserved.join(', ')
  }

  async loadHasTeamnumberButNotReserved () {
    const res = await Http.request('/api/maintenance/teamnumber-not-reserved')
    this.hasTeamnumberButNotReserved = (await res.json()).numberOfFixes
  }

  get numberOfProblems () {
    return (
      this.finishedWithoutTeamnumber.length +
      this.finishedWithoutTeam.length +
      this.finishedWithoutTeamname.length +
      this.finishedWithoutTeamtorally.length +
      this.finishedWithoutCustomertoteam.length +
      this.finishedWithDivertingTeamname.length +
      this.finishedWithDivertingTeamdescription.length +
      this.finishedWithDivertingTeamnumber.length +
      this.doubleTeamnumbers.length
    )
  }

  async loadDoubleTeamnumbers () {
    const res = await Http.request('/api/maintenance/double-teamnumbers')
    this.doubleTeamnumbers = await res.json()
  }

  async tryFixNoCustomertoteam () {
    const res = await Http.request('/api/maintenance/no-customertoteam-fix', {
      method: 'POST'
    })
    this.noCustomertoteamFixes = (await res.json()).numberOfFixes
    this.loadFinishedWithoutCustomertoteam()
  }

  async tryFixNoTeamtorally () {
    const res = await Http.request('/api/maintenance/no-teamtorally-fix', {
      method: 'POST'
    })
    this.noTeamtorallyFixes = (await res.json()).numberOfFixes
    this.loadFinishedWithoutTeamtorally()
  }

  async tryFixNoTeamname () {
    const res = await Http.request('/api/maintenance/no-teamname-fix', {
      method: 'POST'
    })
    this.noTeamnameFixes = (await res.json()).numberOfFixes
    this.loadFinishedWithoutTeamname()
    this.loadFinishedWithDivertingTeamname()
  }

  get finishedWithDivertingTeamnumberString () {
    return this.finishedWithDivertingTeamnumber.join(', ')
  }

  async loadFinishedWithDivertingTeamnumber () {
    const res = await Http.request(
      '/api/maintenance/finished-diverting-teamnumber'
    )
    this.finishedWithDivertingTeamnumber = await res.json()
  }

  get finishedWithDivertingTeamdescriptionString () {
    return this.finishedWithDivertingTeamdescription.join(', ')
  }

  async loadFinishedWithDivertingTeamdescription () {
    const res = await Http.request(
      '/api/maintenance/finished-diverting-teamdescription'
    )
    this.finishedWithDivertingTeamdescription = await res.json()
  }

  get finishedWithDivertingTeamnameString () {
    return this.finishedWithDivertingTeamname.join(', ')
  }

  async loadFinishedWithDivertingTeamname () {
    const res = await Http.request(
      '/api/maintenance/finished-diverting-teamname'
    )
    this.finishedWithDivertingTeamname = await res.json()
  }

  get finishedWithoutCustomertoteamString () {
    return this.finishedWithoutCustomertoteam.join(', ')
  }

  async loadFinishedWithoutCustomertoteam () {
    const res = await Http.request(
      '/api/maintenance/finished-no-customertoteam'
    )
    this.finishedWithoutCustomertoteam = await res.json()
  }

  get finishedWithoutTeamtorallyString () {
    return this.finishedWithoutTeamtorally.join(', ')
  }

  async loadFinishedWithoutTeamtorally () {
    const res = await Http.request('/api/maintenance/finished-no-teamtorally')
    this.finishedWithoutTeamtorally = await res.json()
  }

  get finishedWithoutTeamnameString () {
    return this.finishedWithoutTeamname.join(', ')
  }

  async loadFinishedWithoutTeamname () {
    const res = await Http.request('/api/maintenance/finished-no-teamname')
    this.finishedWithoutTeamname = await res.json()
  }

  get finishedWithoutTeamString () {
    return this.finishedWithoutTeam.join(', ')
  }

  async loadFinishedWithoutTeam () {
    const res = await Http.request('/api/maintenance/finished-no-team')
    this.finishedWithoutTeam = await res.json()
  }

  get finishedWithoutTeamnumberString () {
    return this.finishedWithoutTeamnumber.join(', ')
  }

  async loadFinishedWithoutTeamnumber () {
    const res = await Http.request('/api/maintenance/finished-no-teamnumber')
    this.finishedWithoutTeamnumber = await res.json()
  }
}
